import React from 'react';

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="16" height="16" viewBox="0 0 16 16">
    <g>
      <path
        d="M5,12 C7.209139,12 9,10.209139 9,8 C9,5.790861 7.209139,4 5,4 C2.790861,4 1,5.790861 1,8 C1,10.209139 2.790861,12 5,12 Z M5,13 C2.23857625,13 0,10.7614237 0,8 C0,5.23857625 2.23857625,3 5,3 C7.76142375,3 10,5.23857625 10,8 C10,10.7614237 7.76142375,13 5,13 Z M11,12 C13.209139,12 15,10.209139 15,8 C15,5.790861 13.209139,4 11,4 C8.790861,4 7,5.790861 7,8 C7,10.209139 8.790861,12 11,12 Z M11,13 C8.23857625,13 6,10.7614237 6,8 C6,5.23857625 8.23857625,3 11,3 C13.7614237,3 16,5.23857625 16,8 C16,10.7614237 13.7614237,13 11,13 Z"/>
    </g>
  </svg>
);
